import { FC, useRef } from "react";
import { Button, ButtonGroup, ModalBody, ModalFooter } from "@chakra-ui/react";
import { Modal, UploadAvatarForm } from "components";
import { refreshAvatar, refreshMe } from "domains/account";
import { baseRESTUrl } from "lib/utils";
import { useAppDispatch } from "lib/redux";
import { useToastNotification } from "lib/hooks";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  acceptedFileTypes: string[];
  setThumbnailState: (updatedState: Record<string, any>) => void;
  thumbnailState: any;
  handleFiles: (files: FileList) => void;
  uploadAvatar: (avatar) => void;
}

export const UploadUserAvatarModal: FC<Props> = ({
   isOpen,
   onClose,
   uploadAvatar,
   acceptedFileTypes,
   thumbnailState,
   setThumbnailState,
   handleFiles
}) => {
  const ref = useRef<any>(null);
  const { errorToast } = useToastNotification();
  const dispatch = useAppDispatch();

  const saveThumbnail = async () => {
    try {
      const avatar = ref.current.getImageScaledToCanvas();
      await uploadAvatar(avatar);
      await dispatch(refreshMe(baseRESTUrl())).unwrap();
      dispatch(refreshAvatar())
      onClose();
    } catch (err) {
      errorToast({
        title: 'Error',
        description: err,
      });
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Your Profile Pic">
      <ModalBody>
        <UploadAvatarForm
          ref={ref}
          setThumbnailState={setThumbnailState}
          thumbnailState={thumbnailState}
          handleFiles={handleFiles}
          acceptedFileTypes={acceptedFileTypes}
        />
      </ModalBody>
      <ModalFooter>
        <ButtonGroup width="100%" justifyContent="end">
          <Button variant="cancel" onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={saveThumbnail}>Save</Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  )
}
